import {getPropSafely} from "@/utils/utils";
import styled from "styled-components";
import React from "react";
import GridContainer from "@/components/common/GridContainer";
import {WIDTH} from "@/constants";
import {BREAKPOINTS} from "@/styles/themeSettings";
import VideoWithCover from "@/components/common/VideoWithCover";


const ModuleWrapper = styled(GridContainer)`
    position: relative;
	width: 100vw;
	
	&.width{
        &-${WIDTH.FULL}, &-${WIDTH.MEDIUM},&-${WIDTH.SMALL} {
            > *{
                grid-column: 1/calc(var(--grid-count) + 1);
            }
        }
	}
	

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        &.width{
            &-${WIDTH.FULL}{
				padding: unset;
			}
            &-${WIDTH.MEDIUM} {
                > *{
                    grid-column: 2/calc(var(--grid-count));
                }
            }
            &-${WIDTH.SMALL} {
                > *{
                    grid-column: 4/calc(var(--grid-count) - 2);
                }
            }
        }
    }
`

const SIZE = {
	[WIDTH.FULL]: '(min-width: 1024px) and (orientation: landscape) 100vw, 90vw',
	[WIDTH.MEDIUM]: '(min-width: 1024px) and (orientation: landscape) 75vw, 90vw',
	[WIDTH.SMALL]: '(min-width: 1024px) and (orientation: landscape) 65vw, 90vw',
}

export default function VideoWithCoverModule({ data }) {
	const id = data?.id || ''
	const video = getPropSafely(data, 'video', {})
	const width = getPropSafely(video, 'width', WIDTH.FULL)
	// const width = WIDTH.MEDIUM

	return (
		<ModuleWrapper
			id={id}
			className={`width-${width} no-margin padding`}
		>
			<VideoWithCover data={video} sizes={SIZE[width]}/>
		</ModuleWrapper>
	)
}
